<div class="lnk-page">

  <!-- ── Progress bar ──────────────────────────────── -->
  <div class="lnk-progress" *ngIf="generaleService.disabled">
    <div class="lnk-progress__bar"></div>
  </div>

  <!-- ── Page header ───────────────────────────────── -->
  <header class="lnk-header">
    <h1 class="lnk-header__title">
      <span class="lnk-header__icon">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <path d="M21 15l-5-5L5 21" />
        </svg>
      </span>
      Image &amp; Vidéo
    </h1>

    <!-- Global page filter -->
    <div class="lnk-field" style="width:220px">
      <label class="lnk-label">Filtre Fenêtre</label>
      <div class="lnk-select-wrap">
        <select class="lnk-select" name="fenetre" [(ngModel)]="fenetre" (change)="setDataListe()" required>
          <option *ngFor="let p of listePage" [value]="p.value">{{ p.text }}</option>
        </select>
      </div>
    </div>
  </header>

  <!-- ── Tab bar ───────────────────────────────────── -->
  <div class="lnk-tabs">
    <div class="lnk-tabs__bar">
      <button type="button" class="lnk-tab" [class.active]="tabIndex === 0" (click)="tabIndex = 0">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 6h16M4 12h16M4 18h7" />
        </svg>
        Text
      </button>
      <button type="button" class="lnk-tab" [class.active]="tabIndex === 1" (click)="tabIndex = 1">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <path d="M21 15l-5-5L5 21" />
        </svg>
        Image
      </button>
    </div>

    <!-- ══ TAB 0 — Text ══ -->
    <div class="lnk-tab-panel" [class.active]="tabIndex === 0">
      <div class="lnk-panel">
        <div class="lnk-panel__header">
          <div class="lnk-panel__header-left">
            <span class="lnk-panel__icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M4 6h16M4 12h16M4 18h7" />
              </svg>
            </span>
            Contenu texte
          </div>
          <button type="button" class="lnk-btn lnk-btn--success" (click)="enregistrer()"
            [disabled]="generaleService.disabled">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
              <polyline points="17 21 17 13 7 13 7 21" />
              <polyline points="7 3 7 8 15 8" />
            </svg>
            Enregistrer
          </button>
        </div>

        <div class="lnk-panel__body">
          <!-- Dual editors side by side -->
          <div class="lnk-editors-row">
            <div class="lnk-editor-wrap">
              <label class="lnk-label lnk-label--editor">
                <span class="lnk-lang-badge lnk-lang-badge--fr">FR</span>
                Français
              </label>
              <div class="lnk-editor-box">
                <angular-editor [config]="editorConfig" name="tex1" placeholder="Français…" [(ngModel)]="textFr">
                </angular-editor>
              </div>
            </div>

            <div class="lnk-editor-wrap">
              <label class="lnk-label lnk-label--editor">
                <span class="lnk-lang-badge lnk-lang-badge--en">EN</span>
                Anglais
              </label>
              <div class="lnk-editor-box">
                <angular-editor [config]="editorConfig" name="tex2" placeholder="English…" [(ngModel)]="textEn">
                </angular-editor>
              </div>
            </div>
          </div>

          <!-- List table below -->
          <div class="lnk-list-section">
            <div class="lnk-list-section__title">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="8" y1="6" x2="21" y2="6" />
                <line x1="8" y1="12" x2="21" y2="12" />
                <line x1="8" y1="18" x2="21" y2="18" />
                <line x1="3" y1="6" x2="3.01" y2="6" />
                <line x1="3" y1="12" x2="3.01" y2="12" />
                <line x1="3" y1="18" x2="3.01" y2="18" />
              </svg>
              Liste textes
            </div>
            <app-liste #listeTextComponen [showFilter]="false" [heightTable]="'400'"
              [displayedColumnsBrut]="columnsText" (btnTable)="clickBtnHeat($event)">
            </app-liste>
          </div>
        </div>
      </div>
    </div>

    <!-- ══ TAB 1 — Image ══ -->
    <div class="lnk-tab-panel" [class.active]="tabIndex === 1">
      <div class="lnk-split">

        <!-- LEFT: filter + image grid -->
        <div class="lnk-panel lnk-panel--images">
          <div class="lnk-panel__header">
            <div class="lnk-panel__header-left">
              <span class="lnk-panel__icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <path d="M21 15l-5-5L5 21" />
                </svg>
              </span>
              Images
            </div>
          </div>

          <div class="lnk-panel__body">
            <!-- Filter select (image-tab specific) -->
            <div class="lnk-field">
              <label class="lnk-label">Filtre Fenêtre</label>
              <div class="lnk-select-wrap">
                <select class="lnk-select" name="fenetre2" [(ngModel)]="fenetre" (change)="setDataListe()" required>
                  <option *ngFor="let p of listePage" [value]="p.value">{{ p.text }}</option>
                </select>
              </div>
            </div>

            <!-- Image grid -->
            <div class="lnk-image-grid">
              <div *ngFor="let img of listeImagesToshow" class="lnk-image-card" (click)="openFrmImage(img)">
                <img [id]="img.File_Id" [src]="img.File_Content" alt="" />
                <div class="lnk-image-card__overlay">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                  </svg>
                </div>
              </div>
              <!-- Empty state -->
              <div *ngIf="!listeImagesToshow?.length" class="lnk-empty">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" stroke-width="1.5">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <path d="M21 15l-5-5L5 21" />
                </svg>
                <span>Aucune image</span>
              </div>
            </div>

            <input id="input_file" style="display:none" type="file" name="fghjk" [(ngModel)]="file"
              (change)="onChangeImagefile($event)" />
          </div>
        </div>

        <!-- RIGHT: text editors for image tab -->
        <div class="lnk-panel lnk-panel--text">
          <div class="lnk-panel__header">
            <div class="lnk-panel__header-left">
              <span class="lnk-panel__icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <path d="M4 6h16M4 12h16M4 18h7" />
                </svg>
              </span>
              Textes associés
            </div>
            <button type="button" class="lnk-btn lnk-btn--success" (click)="enregistrer()"
              [disabled]="generaleService.disabled">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                <polyline points="17 21 17 13 7 13 7 21" />
              </svg>
              Enregistrer
            </button>
          </div>

          <div class="lnk-panel__body">
            <div class="lnk-editor-wrap lnk-editor-wrap--stacked">
              <label class="lnk-label lnk-label--editor">
                <span class="lnk-lang-badge lnk-lang-badge--fr">FR</span>
                Français
              </label>
              <div class="lnk-editor-box">
                <angular-editor [config]="editorConfig" name="tex1img" placeholder="Français…" [(ngModel)]="textFr">
                </angular-editor>
              </div>
            </div>

            <div class="lnk-editor-wrap lnk-editor-wrap--stacked" style="margin-top:16px">
              <label class="lnk-label lnk-label--editor">
                <span class="lnk-lang-badge lnk-lang-badge--en">EN</span>
                Anglais
              </label>
              <div class="lnk-editor-box">
                <angular-editor [config]="editorConfig" name="tex2img" placeholder="English…" [(ngModel)]="textEn">
                </angular-editor>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>